import React from 'react';

import { Svg, type SvgProps } from './svg';

export function ChevronLeftIcon(props: SvgProps) {
  return (
    <Svg data-testid="chevron-left-icon" {...props}>
      <path d="M15.4 16.6 10.8 12l4.6-4.6L14 6l-6 6 6 6 1.4-1.4Z" />
    </Svg>
  );
}
